import PropTypes from 'prop-types';
import { SelectGeneric } from 'ypf-pas-general-ui-components';

const ApproverFormSelect = ({ errors, isInvalid, name, onChange, options, value, isDisabled }) => (
  <SelectGeneric
    defaultValueOneOption={false}
    errors={errors}
    isDisabled={isDisabled}
    isInvalid={isInvalid}
    isMulti
    label="Aprobador o grupo"
    name={name}
    onChange={onChange}
    options={options}
    placeholder="Buscar por nombre o grupo"
    value={value}
    variantOptions="info"
    withSelect="100%"
  />
);

ApproverFormSelect.propTypes = {
  errors: PropTypes.string,
  isInvalid: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  value: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

ApproverFormSelect.defaultProps = {
  errors: '',
  isInvalid: false
};

export default ApproverFormSelect;
